/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    _ = require('lodash'),
    //
    phoneify = require('./phoneify'),
    //
    propertiesThatShouldNotBeIncluded = {
        filterSetsListItems: true,
        originalFileName: true
    },
    booleans = {
        canPayForWithHousingSupport: true,
        canPayPrivate: true,
        curfewPolicy: true,
        hasAdminAccess: true,
        isFavorite: true,
        retired: true,
        vacancy: true,
        wantsOurServices: true
    },
    isoDates = {
        availableDate: true
    },
    numerics = {
        bathroomTypeId: true,
        bedroomCount: true,
        buildingAccessTypeIds: true,
        canServeMAWaiversTypeIds: true,
        code: true,
        contactOrganizationRoleTypeId: true,
        contactProgramRoleTypeId: true,
        contractNumberOfBeds: true,
        countyId: true,
        criminalBackgroundTypeIds: true,
        curfewPolicy: true,
        householdTypeIds: true,
        incomeSupportTypeIds: true,
        invalidateCache: true,
        kitchenTypeId: true,
        languagesSpokenTypeIds: true,
        latitude: true,
        latitudeCache: true,
        longitude: true,
        longitudeCache: true,
        mealsServedTypeId: true,
        medicationServicesTypeIds: true,
        miles: true,
        numberOfComparableUnits: true,
        order: true,
        organizationId: true,
        organizationRoleTypeId: true,
        organizationStatusTypeId: true,
        parkingTypeId: true,
        petPolicyTypeIds: true,
        programId: true,
        programStatusTypeId: true,
        programTypeId: true,
        religionActivityTypeIds: true,
        rentDollars: true,
        retired: true,
        serviceForDiagnosisTypeIds: true,
        serviceOnSiteTypeIds: true,
        serviceParticipationTypeIds: true,
        siteTypeId: true,
        smokingPolicyTypeId: true,
        sobrietyPeriodTypeId: true,
        sobrietyPolicyTypeId: true,
        targetPopulationTypeIds: true,
        unitCategoryTypeId: true,
        unitId: true,
        unitStatusTypeId: true,
        vacancyStatusTypeId: true,
        vacancies: true,
        vacancyFillReasonTypeId: true,
        visitorPolicyTypeId: true
    },
    specialCases = {
        canPayForWithHousingSupport: ['boolean'],
        canPayPrivate: ['boolean'],
        id: ['email', 'numeric'],
        phone: ['phone'],
        phoneNumbersOnly: ['phone']
    },
    nullable = {
        countyId: true,
        vacancyFillReasonTypeId: true
    };

module.exports = {
    processor: function (serializedArray, mode) {
        const o = {};
        let a;
        _.each(serializedArray, function (item) {
            // if (item.name === 'canPayForWithHousingSupport') {
            //     console.log('hola, mis!');
            // }
            if (item.name === undefined || item.value === undefined) {
                console.log('booya!');
            }
            if (!propertiesThatShouldNotBeIncluded[item.name]) {
                if (mode === 'filters' && item.name.match(/Id$/)) {
                    item.name += 's';
                }
                if (item.name.match(/Ids$/)) {
                    if (!o[item.name]) {
                        o[item.name] = [];
                    }
                    if (+item.value !== -1) {
                        o[item.name].push(+item.value);
                    }
                } else if (item.value.match(/^true$|^false$/)) {
                    if (!booleans[item.name]) {
                        console.log('formProcessor - unknown boolean:%s', item.name);
                    }
                    o[item.name] = item.value === 'true';
                } else if (numerics[item.name]) {
                    if (+item.value !== -1) { // if -1 we assume it's a sentinal value from a select list and drop it
                        o[item.name] = item.value || !nullable[item.name] ? +item.value : null;
                    }
                } else if (isoDates[item.name]) {
                    try {
                        o[item.name] = new Date(item.value).toISOString();
                    } catch (error) {
                        console.error('formProcessor.processor - exception w/isoDates (name:%s, value:%s)', item.name, item.value);
                    }
                } else if (specialCases[item.name]) {
                    _.each(specialCases[item.name], function (type) {
                        switch (type) {
                            case 'boolean':
                                if (+item.value === -1) {
                                    // if we see the sentry and haven't recorded a value, then it must have gone from checked to unchecked
                                    if (!o[item.name]) {
                                        o[item.name] = false;
                                    }
                                } else {
                                    o[item.name] = item.value === 'true';
                                }
                                break;
                            case 'email':
                                if (!o[item.name] && item.value.indexOf('@') !== -1) { // assume it's valid email if we're gotten this far
                                    o[item.name] = item.value;
                                }
                                break;
                            case 'numeric':
                                if (!o[item.name] && item.value == +item.value) { // jshint ignore:line
                                    o[item.name] = +item.value;
                                }
                                break;
                            case 'phone':
                                o[item.name] = phoneify(item.value);
                                break;
                            default:
                                break;
                        }
                    });
                } else {
                    o[item.name] = _.trim(item.value);
                }
            }
        });
        return o;
    }
};

